import { Route } from '@angular/router';

export const hubRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./features/main/main.component').then((c) => c.MainComponent),
  },
  {
    path: 'services',
    loadComponent: () => import('./features/customize-services/customize-services.component').then((c) => c.CustomizeServicesComponent),
  },
  {
    path: 'search',
    loadComponent: () => import('./features/hub-search/hub-search.component').then((c) => c.HubSearchComponent),
  },
];
